// One analytics page view per address the visitor reaches (lib/analytics.ts):
// the app changes pages without loading, so the tag cannot see it by itself.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../lib/analytics";

export function PageViews() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    trackPageView();
  }, [pathname, search]);
  return null;
}
